import {HttpAxiosRequest} from "../httpAxiosBase";
import {
    SolicitationRequestDocumentationPost,
    SolicitationRequestDocumentationView
} from "../../types/solicitation/solicitationData";

export const HttpSolicitationRequestDocs = {
    getEndpoint: (url: string, solicitationId: number): string => `solicitud/${solicitationId}/pedido-documentacion${url}`,

    getList: (solicitationId: number) : Promise<SolicitationRequestDocumentationView[]> => {
        return HttpAxiosRequest.get(
            HttpSolicitationRequestDocs.getEndpoint('', solicitationId)
        )
    },

    insert: (solicitationId: number, data: SolicitationRequestDocumentationPost) : Promise<any> => {
        return HttpAxiosRequest.post(
            HttpSolicitationRequestDocs.getEndpoint('', solicitationId),
            {...data}
        )
    }
}